/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Formik } from 'formik';
import moment from 'moment';
import { Form } from 'formik-antd';
import _, { isEmpty } from 'lodash';
import { Col, message, Row, Select } from 'antd';
import { addBillRegenration } from 'store/pageSlice';
import { getClientList, getLocations } from 'store/clientSlice';
import { getListofInvoiceV2, regenerateVendorBillV2 } from 'store/vendorBillSliceV2';
import { getProjectListV2 } from 'store/projectSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { Box, FormInput, Text, Button } from 'atoms';
import { search_type, DAY_DATE_FORMAT, DATE_FORMAT } from 'utils';
import { ACL } from 'components/common';
import { AntdTable } from 'components/custom-table/Style';
import { CancelButton } from 'utils/commonStyled';

function getLocalDate(date) {
	// console.log(moment(date).add(330, 'minutes').format(DateFormat));
	// console.log(moment.utc(date, 'MM/DD/YYYY HH:mm').toDate());
	console.log(moment(date));
	console.log(moment(date).add(330, 'minutes'));

	if (date) {
		return moment(date).add(330, 'minutes').format(DAY_DATE_FORMAT);
	}
	return '';
}
const columns = [
	{
		title: 'Trip Date',
		dataIndex: 'reporting_time',
		render: (reporting_time) => <Text overFlow="hidden">{getLocalDate(reporting_time)}</Text>,
	},
	{
		title: 'Trip ID',
		dataIndex: 'id',
	},
	{
		title: 'Trip Type',
		dataIndex: 'trip_type',
	},
	{
		title: 'Project Name',
		dataIndex: 'project_name',
	},
	{
		title: 'Vehicle Type (Vehicle No)',
		dataIndex: 'vehicle_type',
		render: (bill_period, record) => (
			<Text overFlow="hidden">
				{bill_period} - {record?.vehicle_number}
			</Text>
		),
	},
	{
		title: 'Vendor Rate',
		dataIndex: 'vendor_trip_cost',
	},
	{
		title: 'Payable Amount',
		dataIndex: 'vendor_trip_cost',
	},
];

// function getTotalCountSelectedTrips(selectIDs) {
// 	return selectIDs.length;
// }

function getArray(totalAmountIDs) {
	// eslint-disable-next-line func-names
	const result = totalAmountIDs.map(function (x) {
		return parseFloat(x, 10);
	});
	const total = _.sum(result);
	return Math.round(total * 100) / 100;
}

export default function VendorBillRegenrationForm({ vendorId, vendorBillRes, cities }) {
	const { id } = useParams();
	const navigate = useNavigate();
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';
	const [projectList, setProjectList] = useState([]);
	const [selectionType, setSelectionType] = useState([]);
	const [adhocTripData, setAdhocTripData] = useState([]);
	const [tripCount, SetTripCount] = useState('');
	const [totalPayableAmount, setTotalPayableAmount] = useState('');
	const [defaultIDs, setDefaultID] = useState([]);
	const [idValue, setIDValue] = useState('');
	const [selectedCity, SetselectedCity] = useState('');
	const [slectedProject, setSlectedProject] = useState('');

	console.log(vendorId, vendorBillRes, projectList);

	const initialValues = () => ({
		project_location_code: undefined,
		city: undefined,
	});

	console.log(tripCount);

	function getFormattedDate(val) {
		console.log(val);
		const fomatedDate = moment.utc(val).format(DATE_FORMAT);
		const validData = `${fomatedDate} 00:00`;
		return moment.utc(validData).subtract(330, 'minutes').format('MM/DD/YYYY HH:mm');
	}
	function getFormattedEndDate(val) {
		console.log(val);
		const fomatedDate = moment.utc(val).format(DATE_FORMAT);
		const validData = `${fomatedDate} 23:59`;
		return moment.utc(validData).subtract(330, 'minutes').format('MM/DD/YYYY HH:mm');
	}

	const dispatch = useDispatch();
	// eslint-disable-next-line sonarjs/cognitive-complexity
	useEffect(() => {
		if (id && vendorId) {
			// Fetch vendor bill trips
			const tripPayload = {
				vendor_id: vendorId,
				bill_id: id,
				start_date: getFormattedDate(vendorBillRes?.vendor_bill?.bill_start_time),
				end_date: getFormattedEndDate(vendorBillRes?.vendor_bill?.bill_end_time),
			};

			const tripAction = useV2API
				? getListofInvoiceV2({ search_type: 'vendor_bill_trip', data: tripPayload })
				: getClientList({ search_type: 'vendor_bill_trip', filter_by: tripPayload });

			dispatch(tripAction).then((res) => {
				const tripData = useV2API ? res?.rows : res?.data;
				setAdhocTripData(tripData);
				const newFilter = tripData.filter((x) => x.is_vendor_billed === true);
				console.log(newFilter);
				const selectIDs = _.map(newFilter, _.property('id'));
				const totalAmountIDs = _.map(newFilter, _.property('vendor_trip_cost'));
				console.log(totalAmountIDs);
				setTotalPayableAmount(getArray(totalAmountIDs));
				setIDValue(
					tripData.map((item) => ({
						id: item?.id,
						value: parseFloat(item?.vendor_trip_cost),
					}))
				);
				console.log(idValue);
				setDefaultID(selectIDs);
				setSelectionType(selectIDs);
				SetTripCount(selectIDs.length);

				if (res) {
					setAdhocTripData(tripData);
				} else {
					setAdhocTripData([]);
				}
			});
			// Location API stays V1
			dispatch(
				getLocations({
					search_type: search_type?.location,
					filter_by: {},
				})
			);
			// Fetch projects for dropdown
			if (useV2API) {
				dispatch(
					getProjectListV2({
						filter_by: { vendor_id: vendorId },
						pagination: { per_page: 100 },
					})
				).then((res) => {
					const pro_Data = (res?.rows || []).map((item) => ({
						label:
							item?.project_location_code || item?.project_code || item?.project_name,
						value: item?.project_id || item?.id,
					}));

					const jsonObject = pro_Data.map(JSON.stringify);
					const uniqueSet = new Set(jsonObject);
					const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
					uniqueArray.unshift({ value: '', label: 'All' });
					setProjectList(uniqueArray);
				});
			} else {
				dispatch(
					getClientList({
						search_type: 'vendor_contract',
						filter_by: {
							vendor_id: vendorId,
						},
					})
				).then((res) => {
					const pro_Data = res?.data?.map((item) => ({
						label: item?.project_location_code,
						value: item?.project_id,
					}));

					const jsonObject = pro_Data.map(JSON.stringify);
					const uniqueSet = new Set(jsonObject);
					const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
					uniqueArray.unshift({ value: '', label: 'All' });
					setProjectList(uniqueArray);
				});
			}
		}
	}, [dispatch, id, vendorId, useV2API]);

	useEffect(() => {
		if (id && vendorId) {
			const filterPayload = {
				bill_id: id,
				vendor_id: vendorId,
				start_date: getFormattedDate(vendorBillRes?.vendor_bill?.bill_start_time),
				end_date: getFormattedEndDate(vendorBillRes?.vendor_bill?.bill_end_time),
				city: selectedCity !== '' ? selectedCity : '',
				project_id: slectedProject !== '' ? slectedProject : '',
			};

			const tripAction = useV2API
				? getListofInvoiceV2({ search_type: 'vendor_bill_trip', data: filterPayload })
				: getClientList({ search_type: 'vendor_bill_trip', filter_by: filterPayload });

			dispatch(tripAction).then((res) => {
				const tripData = useV2API ? res?.rows : res?.data;
				setAdhocTripData(tripData);
				const newFilter = tripData.filter((x) => x.is_vendor_billed === true);
				console.log(newFilter);
				const selectIDs = _.map(newFilter, _.property('id'));
				const totalAmountIDs = _.map(newFilter, _.property('vendor_trip_cost'));
				console.log(totalAmountIDs);
				setTotalPayableAmount(getArray(totalAmountIDs));
				setIDValue(
					tripData.map((item) => ({
						id: item?.id,
						value: parseFloat(item?.vendor_trip_cost),
					}))
				);
				console.log(idValue);
				setDefaultID(selectIDs);
				setSelectionType(selectIDs);
				SetTripCount(selectIDs.length);
			});
		}
	}, [dispatch, id, slectedProject, selectedCity, useV2API]);

	// const handleSubmit = () => {
	// 	const payload = {
	// 		update_type: 'vendor_bill_regenerate',
	// 		data: {
	// 			vendor_bill_id: Number(vendorId),
	// 			trip_ids: selectionType,
	// 		},
	// 	};
	// 	console.log(payload);

	// 	dispatch(updateVendorBill({ data: payload }))
	// 		.then((res) => {
	// 			console.log(res);
	// 			// '/vendor-bill-edting/:id
	// 			window.location = `${window.origin}/vendor-invoices`;
	// 		})
	// 		.catch(() => {});
	// };

	// function getSlectedRows(tripsData) {
	// 	const selectedRows = tripsData?.map((value) => {
	// 		if (value?.is_vendor_billed === true) {
	// 			return value?.id;
	// 		}
	// 		return '';
	// 	});

	// 	const finalSelectedRows = selectedRows.filter(Boolean);

	// 	setSelectionType(finalSelectedRows);
	// }

	function handleCitiesChange(e) {
		console.log('citychnagedata', e);
		if (e) {
			SetselectedCity(e);
		} else {
			SetselectedCity(false);
		}
	}
	function handleProjectChange(e) {
		console.log('projectchangedata', e);

		setSlectedProject(e);
	}

	const handleSubmit = ({ setSubmitting, setErrors }) => {
		if (defaultIDs?.length > 0) {
			if (useV2API) {
				dispatch(
					regenerateVendorBillV2({
						req_data: {
							vendor_bill_id: id,
							trip_ids: defaultIDs,
						},
					})
				)
					.then((res) => {
						navigate(`/vendor-bill-edting/${res?.data?.new_bill_id}`);
					})
					.catch(() => {
						setSubmitting(false);
					});
			} else {
				const payload = {
					update_type: 'vendor_bill_regenerate',
					data: {
						vendor_bill_id: id,
						trip_ids: defaultIDs,
					},
				};

				dispatch(addBillRegenration({ data: payload, setErrors }))
					.then((res) => {
						navigate(`/vendor-bill-edting/${res?.data?.new_bill_id}`);
					})
					.catch(() => {
						setSubmitting(false);
					});
			}
		} else {
			message.error('please select trips');
		}
	};

	const rowSelection = {
		type: selectionType,
		preserveSelectedRowKeys: false,
		onChange: (newSelectedRowKeys) => {
			console.log(newSelectedRowKeys);
			SetTripCount(newSelectedRowKeys.length);
			setDefaultID(newSelectedRowKeys);

			console.log('adhocTripData', adhocTripData);
			console.log('newSelectedRowKeys', newSelectedRowKeys);

			const amountsArray = adhocTripData
				?.filter((item) => newSelectedRowKeys?.includes(item?.id))
				?.map((it) => Number(it?.vendor_trip_cost));

			console.log('amountsArray', amountsArray);

			const totalAmount = !isEmpty(amountsArray) ? amountsArray.reduce((a, b) => a + b) : 0;

			console.log('totalAmount', totalAmount);

			setTotalPayableAmount(totalAmount);
			setSelectionType(newSelectedRowKeys);
			// console.log(selectedRowsIds);
			console.log(selectionType);
		},
		getCheckboxProps: (record) => {
			// console.log(record);
			const rowsID = record?.is_vendor_billed === true;
			console.log(rowsID);
		},
		selectedRowKeys: defaultIDs,
	};

	console.log(selectionType);
	console.log(defaultIDs);
	console.log(idValue);

	return (
		<Formik initialValues={initialValues} onSubmit={handleSubmit}>
			{({ values, errors }) => (
				<Box>
					<ACL action="create" module="vendor_invoice"></ACL>
					<Form>
						{console.log(values, errors)}
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									Bill Number : {vendorBillRes?.vendor_bill?.vendor_bill_no}
								</Col>
								<Col lg={12}>
									Vendor Name : {vendorBillRes?.vendor_details?.vendor_name}
								</Col>
							</Row>
							<Box padding="1.5rem 2rem" background="#fff"></Box>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									Bill Period : {vendorBillRes?.vendor_bill?.bill_period}
								</Col>
								<Col lg={12}>
									Total Payable Amount :{' '}
									{vendorBillRes?.vendor_bill?.total_payable_amount}
								</Col>
							</Row>
							<Box padding="1.5rem 2rem" background="#fff"></Box>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									Bill Revision : {vendorBillRes?.vendor_bill?.version}
								</Col>
							</Row>
							<Box padding="1.5rem 2rem" background="#fff"></Box>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="city" label="Select City">
										<Select
											showSearch
											// onClear
											name="city"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											options={cities}
											placeholder="Select"
											onChange={(e) => handleCitiesChange(e)}
										/>
									</FormInput>
								</Col>

								<Col lg={12}>
									{/* <FormInput name="project_id" label="Select Project">
										<Select
											name="project_id"
											showSearch
											onClear
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											options={projectList}
										/>
									</FormInput> */}
									{console.log(projectList)}
									<FormInput name="project_id" label="Select Project ">
										<Select
											showSearch
											// onClear
											defaultValue=""
											name="project_id"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											options={projectList}
											placeholder="Select"
											onChange={(e) => handleProjectChange(e)}
										/>
									</FormInput>
								</Col>
							</Row>
							<Box backgroundColor="#f5f5f5" padding="1.5rem">
								<Row>
									<Col lg={12}>Total selected Trips: {tripCount}</Col>

									<Col lg={12}>Total Bill Amount: {totalPayableAmount || 0}</Col>
								</Row>
							</Box>
						</Box>
						<AntdTable
							rowKey="id"
							rowSelection={rowSelection}
							columns={columns}
							dataSource={adhocTripData}
						/>

						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton
								onClick={() => navigate('/vendor-invoices')}
								type="button"
							>
								Cancel
							</CancelButton>
							<Button
								borderRadius="4px"
								backgroundColor="#18405d"
								type="submit"
								disabled={isEmpty(defaultIDs)}
							>
								Submit
							</Button>
						</Box>
					</Form>

					{/* <Debug /> */}
				</Box>
			)}
		</Formik>
	);
}

VendorBillRegenrationForm.propTypes = {
	vendorId: PropTypes.any,
	vendorBillRes: PropTypes.any,
	cities: PropTypes.array,
};
